export default "__VITE_ASSET__CjHAssjF__"